<template lang="pug">
  .lg_container
    <global-header></global-header>
    .school_list(:style="'minHeight:'+ minHeight")
      .school_item(v-for="item in websiteInfo.campusList" :key="item.id")
        //- 校区信息
        .school_item_info
          //- 校区轮播图
          van-swipe(v-if="item.imageUrl" :autoplay="3000" indicator-color="white")
            van-swipe-item(v-for="(url, index) in item.imageUrl.split(',')" :key="index")
              img.bannerImg(:src="url")
          .school_head
            .school_name.van-ellipsis {{item.name}}
            .school_direction(@click="onCampus(item.address)")
              img(src="@/assets/contactUs/direction.png")
              span 怎么走
          .school_box
            img(src="@/assets/contactUs/site.png")
            .school_con
              .school_lab 地址
              .school_val.van-ellipsis {{item.address}}
          .school_box
            img(src="@/assets/contactUs/phone.png")
            .school_con
              .school_lab 服务热线
              .school_val {{item.mobile || '暂无信息请扫描底部二维码获取'}}
    <global-footer></global-footer>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
export default {
  name: 'ContactUs',
  components: {
    GlobalHeader,
    GlobalFooter
  },
  computed: {
    ...mapGetters([
      'websiteInfo'
    ])
  },
  data() {
    return {
      proportion: (document.documentElement.clientWidth || document.body.clientWidth) / 375,
      minHeight: ''
    }
  },
  mounted() {
    this.minHeight = (window.innerHeight || document.documentElement.clientHeight) - 318 * this.proportion + 'px'
  },
  methods: {
    onCampus(site) {
      window.open('http://api.map.baidu.com/geocoder?address=' + site + '&output=html&src=webapp.baidu.openAPIdemo', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.lg_container {
  width: 100%;
  box-sizing: border-box;
  .school_list {
    padding: 0 20px;
    .school_item {
      margin-bottom: 20px;
      .school_item_info {
        padding: 0 18px;
        background: #ffffff;
        box-shadow: 0px 4px 8px 0px rgba(26, 153, 135, 0.15);
        border-radius: 14px;
        border: 1px solid #efefef;
        .school_head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 50px;
          width: 100%;
          .school_name {
            color: #33373f;
            font-size: 16px;
            flex: 1;
          }
          .school_direction {
            width: 84px;
            height: 28px;
            background: #ffffff;
            border-radius: 14px;
            border: 1px solid #5bc255;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 13px;
              height: 18px;
              margin-right: 5px;
            }
            span {
              color: #5BC255;
              font-size: 14px;
            }
          }
        }
        .school_box {
          display: flex;
          align-items: center;
          margin-bottom: 18px;
          img {
            width: 18px;
            height: 22px;
          }
          .school_con {
            flex: 1;
            margin-left: 10px;
            .school_val {
              color: #666A72;
              width: 270px;
            }
          }
        }
      }
    }
  }
}
::v-deep .van-swipe {
  margin-top: 14px;
  margin-bottom: 14px;
  .van-swipe-item {
    width: 100%;
    height: 200px;
    .bannerImg {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
      border-radius:6px;
      overflow: hidden;
    }
  }
}
</style>
